import React from 'react';
import { Button, Drawer, Space } from 'antd';

interface MobileFilterSheetProps {
  open: boolean;
  title: string;
  onClose: () => void;
  onReset?: () => void;
  onApply?: () => void;
  applyText?: string;
  children: React.ReactNode;
}

const MobileFilterSheet: React.FC<MobileFilterSheetProps> = ({
  open,
  title,
  onClose,
  onReset,
  onApply,
  applyText = '应用筛选',
  children,
}) => (
  <Drawer
    placement="bottom"
    open={open}
    onClose={onClose}
    title={title}
    height="auto"
    styles={{
      body: { paddingBottom: 20 },
      header: { paddingBottom: 12 },
      content: {
        borderTopLeftRadius: 24,
        borderTopRightRadius: 24,
        overflow: 'hidden',
      },
    }}
    extra={(
      <Space size={8}>
        {onReset ? (
          <Button onClick={onReset}>
            重置
          </Button>
        ) : null}
        {onApply ? (
          <Button type="primary" onClick={onApply}>
            {applyText}
          </Button>
        ) : null}
      </Space>
    )}
  >
    {children}
  </Drawer>
);

export default MobileFilterSheet;
